import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Box, Button, CircularProgress, Collapse } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import 'moment/locale/pt-br';

import useFetch from '../../../../hooks/useFetch';
import { useAlert } from '../../../../hooks/useAlert';

import { instanceAxios } from '../../../../InstanceAxios';

import { CEP_PATTERN } from '../../../../consts/patterns';

import { Input, InputMask, Select } from '../../../../components/Form';

import { Container } from '../../../../components/Layouts/Container';

import schema from './schema';

import { Title, Centered } from './styles';
import { CAMPO_OBRIGATORIO, UFS_OPTIONS } from '../../../../consts/common';
import { getEnderecoByCep } from '../../../../utils/getEnderecoByCEP';

function EnderecoUsuario() {
  const { isLoading, data } = useFetch('/usuario/endereco');

  const { alert, openAlert, closeAlert } = useAlert();

  const [formSubmiting, setFormSubmiting] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty, dirtyFields, values },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(schema),
  });

  // atualiza os dados do usuário quando a requisicao é concluida
  useEffect(() => {
    reset(data);
  }, [data]);

  async function handleCepBlur(cepValue) {
    if (cepValue) {
      const response = await getEnderecoByCep(cepValue);

      reset(
        { ...response },
        {
          keepDefaultValues: true,
        }
      );
    }
  }

  async function onSubmit(formData) {
    try {
      setFormSubmiting(true);

      const updatedData = {
        ...formData,
      };

      // remove campos que não foram modificados
      Object.entries(updatedData).forEach(([key]) => {
        if (!Object(dirtyFields).hasOwnProperty(key)) {
          delete updatedData[key];
        }
      });

      const token = localStorage.getItem('toobiauth');

      await instanceAxios(token).put('/usuario/endereco', updatedData);

      openAlert('Dados atualizados com sucesso!');

      reset(formData);
    } catch (err) {
      console.log(err);

      openAlert('Erro ao atualizar dados!', 'error');
    } finally {
      setFormSubmiting(false);
    }
  }

  return (
    <Container isLoading={isLoading}>
      <Collapse in={alert.open}>
        <Alert severity={alert.severity} onClick={closeAlert}>
          {alert.message}
        </Alert>
      </Collapse>
      <Title>Endereço</Title>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InputMask
            control={control}
            id="cep"
            name="cep"
            label="CEP"
            variant="outlined"
            pattern={CEP_PATTERN}
            error={!!errors?.cep}
            helperText={errors?.cep ? errors.cep.message : CAMPO_OBRIGATORIO}
            onBlur={(event) => handleCepBlur(event?.nativeEvent?.target?.value)}
          />
        </Grid>
        <Input control={control} id="ibge" name="ibge" hidden />
        <Grid item xs={6}>
          <Input
            control={control}
            id="Logradouro"
            name="logradouro"
            label="Logradouro"
            placeholder="Logradouro"
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            control={control}
            id="numero"
            name="numero"
            label="Número"
            placeholder="Número"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            control={control}
            id="complemento"
            name="complemento"
            label="Complemento"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Complemento"
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            control={control}
            id="bairro"
            name="bairro"
            label="Bairro"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Bairro"
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            control={control}
            id="cidade"
            name="cidade"
            label="Cidade"
            placeholder="Cidade"
            variant="outlined"
            error={!!errors?.cidade}
            helperText={
              errors?.cidade ? errors.cidade.message : CAMPO_OBRIGATORIO
            }
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <Select
            control={control}
            id="estado"
            name="estado"
            label="Estado"
            options={UFS_OPTIONS}
            error={!!errors?.estado}
            helperText={errors?.estado ? errors.estado.message : ''}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
      </Grid>
      <Centered>
        <Box marginTop={4}>
          <Button
            onClick={handleSubmit(onSubmit)}
            size="medium"
            variant="contained"
            color="primary"
            disabled={!isDirty || formSubmiting}
          >
            {formSubmiting ? (
              <CircularProgress color="primary" size={25} />
            ) : (
              'Atualizar dados'
            )}
          </Button>
        </Box>
      </Centered>
    </Container>
  );
}

export default EnderecoUsuario;
